import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showTicketFormUi } from '../../../../../../app/store/slices/ticket/ticket';
import ManageTicket from '../../../../../../components/Cards/ManageTicket';
import styles from '../../../../../../styles/module/TicketForm.module.css';
import CreateTicket from '../../../../../../assets/images/createTicket.svg';
import { Tooltip, Zoom } from '@mui/material';
import CircularLoader from '../../../../../../animation/CircularLoader';
import DeleteDialog from '../../../../../../components/Dialog/DeleteDialog';
import useMarkTicketSoldOut from './hooks/useMarkTicketSoldOut';
import useMarkTicketSaleEnded from './hooks/useMarkTicketSaleEnded';
import useDeleteTicket from './hooks/useDeleteTicket';
import { useEventStatus } from '../../../../../../hooks/event-hooks/useEventStatus';

function TicketList() {
    const { shouldShowAddTicketButton } = useEventStatus();
    const {
        openSoldOutDialog,
        handleOpenSoldOutDialog,
        handleCloseSoldOutDialog,
        markTicketSoldOut
    } = useMarkTicketSoldOut();
    const {
        openSaleEndedDialog,
        handleOpenSaleEndedDialog,
        handleCloseSaleEndedDialog,
        markTicketSaleEnded
    } = useMarkTicketSaleEnded();
    const {
        openDeleteDialog,
        handleOpenDeleteDialog,
        handleCloseDeleteDialog,
        deleteTicket,
        fetchTicketById,
        cannotDelete
    } = useDeleteTicket();
    const { tickets, loading } = useSelector((state) => state.ticket);

    return (
        <React.Fragment>
            <div className={styles.ticketListingContainer}>
                <div className={styles.ticketListing}>
                    {tickets?.map((ticket) => (
                        <ManageTicket
                            key={ticket.ticket_id}
                            price={ticket.price}
                            gstRate={ticket.gst_rate}
                            ticketId={ticket.ticket_id}
                            ticketName={ticket.ticket_name}
                            totalTicketQty={ticket.quantity}
                            ticketStatus={ticket.sale_status}
                            soldTicketQty={ticket.ticket_sold}
                            ticketDescription={ticket.description}
                            exceedStatus={ticket.exceed_ticket_qty}
                            salePeriodEndDate={ticket.ticket_sale_end}
                            entryPerTicket={ticket.attendees_per_ticket}
                            salePeriodStartDate={ticket.ticket_sale_start}
                            ticketSchedule={ticket.ticketValidFor?.event_schedule}
                            onMarkAsSoldOut={() => handleOpenSoldOutDialog(ticket.ticket_id)}
                            onEndSale={() => handleOpenSaleEndedDialog(ticket.ticket_id)}
                            onDelete={() => handleOpenDeleteDialog(ticket.ticket_id)}
                            onViewTicket={() => fetchTicketById(ticket.ticket_id)}
                        />
                    ))}
                </div>

                {/* {shouldShowAddTicketButton && <AddTicket />} */}
                <AddTicket />
            </div>
            <DeleteDialog
                open={openSoldOutDialog}
                onClose={handleCloseSoldOutDialog}
                onDeleteConfirm={markTicketSoldOut}
                primaryButtonText="Sold Out"
                loader={loading}
                dialogTitle="Mark Ticket as Sold Out?"
                dialogDescription="Are you sure you want to mark this ticket as sold out? This action cannot be undone."
            />
            <DeleteDialog
                open={openSaleEndedDialog}
                onClose={handleCloseSaleEndedDialog}
                onDeleteConfirm={markTicketSaleEnded}
                primaryButtonText="Sale End"
                loader={loading}
                dialogTitle="Mark Ticket Sale Ended?"
                dialogDescription="Are you sure you want to mark this ticket sale as ended? This action cannot be undone."
            />
            <DeleteDialog
                open={openDeleteDialog}
                onClose={handleCloseDeleteDialog}
                onDeleteConfirm={deleteTicket}
                loader={loading}
                shouldDisabledBtns={cannotDelete}
                dialogTitle={cannotDelete ? 'Cannot Delete Ticket!' : 'Delete Ticket?'}
                dialogDescription={
                    cannotDelete
                        ? 'This ticket has been sold and cannot be deleted.'
                        : 'Are you sure you want to delete this ticket? This action cannot be undone.'
                }
            />
        </React.Fragment>
    );
}

export default TicketList;

function AddTicket() {
    const dispatch = useDispatch();
    return (
        <Tooltip title="Add Ticket" placement="left" slots={{ transition: Zoom }} arrow>
            <div
                className={styles.addTicketContainer}
                onClick={() => dispatch(showTicketFormUi({ showTicketForm: true }))}
            >
                <img src={CreateTicket} alt="Create Ticket" />
            </div>
        </Tooltip>
    );
}
